/*
 * Supreme Phone Parts: product details area (snippets/spp-details.liquid). Progressive enhancement only:
 * without this file the description is still fully laid out and readable (assets/spp-details.css).
 * 1. At a glance: copies five rows of the description's spec list into a card beside the quick answer
 *    (CSS cannot duplicate content). The spec table keeps every row.
 * 2. Moves the "Signs it needs replacing" card beside the overview text (CSS cannot move it across
 *    sections). The check-model card stays in "Is this the right part?".
 * 3. Keeps model numbers such as SM-A156B on one line (no break at the hyphen).
 * 4. Marks the pill of the section in view (black pill, aria-current) and keeps it scrolled into view;
 *    a pill click scrolls the section to just under the stuck header and nav and moves focus to it.
 * Nothing in the description's text or JSON-LD is changed.
 */
(function () {
  'use strict';

  var GLANCE = ['compatible with', 'model numbers', 'part', 'quality', 'installation'];

  function label(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function addGlance(art) {
    var spec = art.querySelector('dl.spec');
    var qa = art.querySelector('.wrap > .qa');
    if (!spec || !qa || art.querySelector('.sppd-glance')) return;
    var rows = {};
    var dts = spec.querySelectorAll('dt');
    for (var i = 0; i < dts.length; i++) {
      var dd = dts[i].nextElementSibling;
      if (dd && dd.tagName === 'DD') rows[label(dts[i])] = [dts[i], dd];
    }
    var dl = document.createElement('dl');
    dl.className = 'sppd-glance';
    GLANCE.forEach(function (key) {
      if (!rows[key]) return;
      var row = document.createElement('div');
      row.appendChild(rows[key][0].cloneNode(true));
      row.appendChild(rows[key][1].cloneNode(true));
      dl.appendChild(row);
    });
    if (dl.children.length < 3) return;
    var top = document.createElement('div');
    top.className = 'sppd-top';
    qa.parentNode.insertBefore(top, qa);
    top.appendChild(qa);
    top.appendChild(dl);
  }

  function moveSigns(art) {
    var what = art.querySelector('section[aria-labelledby="what"]');
    var list = art.querySelector('section[aria-labelledby="right"] .two > .card ul.tick');
    var card = list && list.closest('.card');
    if (!what || !card || what.querySelector('.sppd-two')) return;
    var paras = what.querySelectorAll(':scope > p:not(.eb)');
    if (!paras.length) return;
    var two = document.createElement('div');
    two.className = 'sppd-two';
    var body = document.createElement('div');
    body.className = 'sppd-body';
    for (var i = 0; i < paras.length; i++) body.appendChild(paras[i]);
    two.appendChild(body);
    two.appendChild(card);
    what.appendChild(two);
  }

  // Wrap model numbers such as "SM-A156B" in a nowrap span: browsers may break a line after a hyphen,
  // which splits the code over two lines. The text itself is unchanged, so FAQ JSON-LD still matches it.
  var CODE = /\b(?:SM-[A-Z0-9]+(?:\/[A-Z0-9]+)*|USB-C|[A-Z]{1,4}-[A-Z0-9]*\d[A-Z0-9]*)\b/g;

  function noWrapCodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentNode;
        if (!parent || parent.closest('script, style, svg, .sppd-nw')) return NodeFilter.FILTER_REJECT;
        CODE.lastIndex = 0;
        return CODE.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      // One wrapper per original text node: inside a grid or flex parent (the quick answer, FAQ summaries)
      // every child and every loose text run is its own item, so the pieces must stay in a single box.
      var run = document.createElement('span');
      run.className = 'sppd-run';
      var last = 0;
      var match;
      CODE.lastIndex = 0;
      while ((match = CODE.exec(text))) {
        if (match.index > last) run.appendChild(document.createTextNode(text.slice(last, match.index)));
        var span = document.createElement('span');
        span.className = 'sppd-nw';
        span.textContent = match[0];
        run.appendChild(span);
        last = match.index + match[0].length;
      }
      if (last < text.length) run.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(run, node);
    });
  }

  function spy(root) {
    var nav = root.querySelector('.sppd-nav');
    if (!nav) return;
    var items = [];
    var links = nav.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < links.length; i++) {
      var target = document.getElementById(links[i].getAttribute('href').slice(1));
      if (target) items.push({ a: links[i], target: target, el: target.closest('section') || target });
    }
    // Extra blocks that belong to an existing pill, e.g. the company card under "About Supreme".
    var extra = root.querySelectorAll('[data-sppd-pill]');
    for (var e = 0; e < extra.length; e++) {
      var owner = nav.querySelector('a[href="' + extra[e].getAttribute('data-sppd-pill') + '"]');
      if (owner) items.push({ a: owner, target: extra[e], el: extra[e], extra: true });
    }
    items.sort(function (x, y) {
      return x.el.compareDocumentPosition(y.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    if (!items.length) return;
    var current = null;
    var timer = 0;
    var lockUntil = 0;

    // Where the nav's bottom edge sits once it is stuck under the theme's sticky header.
    function navOffset() {
      return (parseFloat(window.getComputedStyle(nav).top) || 0) + nav.offsetHeight;
    }

    function setCurrent(next) {
      if (next === current) return;
      if (current && current.a !== next.a) {
        current.a.classList.remove('on');
        current.a.removeAttribute('aria-current');
      }
      current = next;
      current.a.classList.add('on');
      current.a.setAttribute('aria-current', 'true');
      if (nav.scrollWidth > nav.clientWidth) {
        var left = current.a.offsetLeft;
        var right = left + current.a.offsetWidth;
        if (left < nav.scrollLeft || right > nav.scrollLeft + nav.clientWidth) nav.scrollLeft = Math.max(0, left - 16);
      }
    }

    // The section whose top has passed a line 30% down the visible area under the nav is current.
    function update() {
      timer = 0;
      if (Date.now() < lockUntil) return;
      var off = navOffset();
      var line = off + Math.max(24, (window.innerHeight - off) * 0.3);
      var next = items[0];
      for (var j = 0; j < items.length; j++) {
        if (items[j].el.getBoundingClientRect().top <= line) next = items[j];
      }
      setCurrent(next);
    }

    function queue() {
      if (!timer) timer = window.setTimeout(update, 60);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(queue, { rootMargin: '-' + Math.round(navOffset()) + 'px 0px 0px 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });
      items.forEach(function (it) { io.observe(it.el); });
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);

    // Pill click: scroll the section's top to just under the stuck nav, then move focus there.
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      var item = null;
      for (var k = 0; k < items.length; k++) if (items[k].a === link && !items[k].extra) item = items[k];
      if (!item || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = window.pageYOffset + item.el.getBoundingClientRect().top - navOffset() - 8;
      lockUntil = Date.now() + (reduce ? 0 : 900);
      setCurrent(item);
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduce ? 'auto' : 'smooth' });
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', link.getAttribute('href'));
      if (!item.target.hasAttribute('tabindex')) item.target.setAttribute('tabindex', '-1');
      item.target.focus({ preventScroll: true });
      // The theme compacts its sticky header once the page scrolls, so re-check the landing spot.
      window.setTimeout(function () {
        var drift = item.el.getBoundingClientRect().top - navOffset() - 8;
        if (Math.abs(drift) > 3) window.scrollBy(0, Math.round(drift));
        update();
      }, reduce ? 150 : 950);
    });

    update();
  }

  function init() {
    var root = document.getElementById('sppd');
    if (!root || root.hasAttribute('data-sppd-ready')) return;
    root.setAttribute('data-sppd-ready', '');
    var art = root.querySelector('#sppd-desc #spp');
    if (art) {
      try { addGlance(art); } catch (e) { /* layout stays as rendered */ }
      try { moveSigns(art); } catch (e) { /* layout stays as rendered */ }
      try { noWrapCodes(art); } catch (e) { /* text stays as rendered */ }
    }
    spy(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
